import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("div", {
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticClass: "left",
    attrs: {
      src: require("../assets/images/arrow.png"),
      alt: ""
    }
  })])]), _vm._m(0), _c("div", {
    staticClass: "login-con"
  }, [_c("div", {
    staticClass: "login-box"
  }, [_c("div", {
    staticClass: "account"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Account")]), _c("div", {
    staticClass: "bottom"
  }, [_c("span", {
    on: {
      click: _vm.getCountry
    }
  }, [_vm._v(_vm._s(_vm.countryCode) + " "), _c("span", [_vm._v("▼")])]), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userName,
      expression: "userName"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Phone/Email"
    },
    domProps: {
      value: _vm.userName
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.userName = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".account .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".account .bottom");
      }
    }
  })])]), _c("div", {
    staticClass: "verificationCode"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Verification Code")]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verificationCode,
      expression: "verificationCode"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Verification Code"
    },
    domProps: {
      value: _vm.verificationCode
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.verificationCode = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".verificationCode .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".verificationCode .bottom");
      }
    }
  }), _c("span", {
    staticClass: "send-btn",
    on: {
      click: _vm.send
    }
  }, [_vm._v(_vm._s(_vm.$t("send")))])])]), _c("div", {
    staticClass: "password1"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Password")]), _c("div", {
    staticClass: "bottom"
  }, [_vm.type === "checkbox" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    attrs: {
      placeholder: "Enter Password",
      type: "checkbox"
    },
    domProps: {
      checked: Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : _vm.password
    },
    on: {
      input: _vm.input,
      focus: function focus($event) {
        return _vm.focus(".password1 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password1 .bottom");
      },
      change: function change($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.password = $$c;
        }
      }
    }
  }) : _vm.type === "radio" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    attrs: {
      placeholder: "Enter Password",
      type: "radio"
    },
    domProps: {
      checked: _vm._q(_vm.password, null)
    },
    on: {
      input: _vm.input,
      focus: function focus($event) {
        return _vm.focus(".password1 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password1 .bottom");
      },
      change: function change($event) {
        _vm.password = null;
      }
    }
  }) : _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    attrs: {
      placeholder: "Enter Password",
      type: _vm.type
    },
    domProps: {
      value: _vm.password
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.password = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".password1 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password1 .bottom");
      }
    }
  }), _c("div", {
    on: {
      click: function click($event) {
        return _vm.showWord(_vm.type);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../assets/images/eyes.png"),
      alt: ""
    }
  })])])]), _c("div", {
    staticClass: "password2"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Password")]), _c("div", {
    staticClass: "bottom"
  }, [_vm.verifyType === "checkbox" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Password",
      type: "checkbox"
    },
    domProps: {
      checked: Array.isArray(_vm.verifyPassword) ? _vm._i(_vm.verifyPassword, null) > -1 : _vm.verifyPassword
    },
    on: {
      input: _vm.input,
      focus: function focus($event) {
        return _vm.focus(".password2 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password2 .bottom");
      },
      change: function change($event) {
        var $$a = _vm.verifyPassword,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.verifyPassword = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.verifyPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.verifyPassword = $$c;
        }
      }
    }
  }) : _vm.verifyType === "radio" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Password",
      type: "radio"
    },
    domProps: {
      checked: _vm._q(_vm.verifyPassword, null)
    },
    on: {
      input: _vm.input,
      focus: function focus($event) {
        return _vm.focus(".password2 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password2 .bottom");
      },
      change: function change($event) {
        _vm.verifyPassword = null;
      }
    }
  }) : _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Password",
      type: _vm.verifyType
    },
    domProps: {
      value: _vm.verifyPassword
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.verifyPassword = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".password2 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password2 .bottom");
      }
    }
  }), _c("div", {
    on: {
      click: function click($event) {
        return _vm.showVerifyWord(_vm.verifyType);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../assets/images/eyes.png"),
      alt: ""
    }
  })])])])]), _c("div", {
    class: ["btn", {
      active: _vm.isActive
    }],
    on: {
      click: _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t("Confirm")))])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "greetings"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Forgot Password")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };